import { Injectable } from '@angular/core';
import { Angulartics2 } from 'angulartics2';
import { DMPEventsSenderService } from './dmpevents-sender.service';

@Injectable({
  providedIn: 'root',
})
export class DMPAngularticsProviderService {

  constructor(private angulartics2: Angulartics2,
              private eventsSender: DMPEventsSenderService) { }

  public startTracking(): void {
    this.angulartics2.pageTrack
      .pipe(this.angulartics2.filterDeveloperMode())
      .subscribe(x => this.pageTrack(x.path));
  }

  private pageTrack(path: string | undefined): void {
    this.eventsSender.sendWebformEvent({ event_type: 'page_view', page: path || '' });
  }
}
